import { render, staticRenderFns } from "./PastCommunications.vue?vue&type=template&id=b4d8d69a&"
import script from "./PastCommunications.vue?vue&type=script&lang=ts&"
export * from "./PastCommunications.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports